// Internal modules
import { KYC_DOB_NATIONALITY, KYC_DOB_NATIONALITY_ID } from '../constants';
import {
  MARKETING_OPT_IN,
  SIGNUP_AGREE_TO_PRIVACY_STATEMENTS,
  SIGNUP_AGREE_TO_TERMS,
  THIRD_PARTY_DATA_CONSENT,
  UNIQUE_INFORMATION_PROCESSING,
} from './constants';

/* eslint sort-keys: 0 */
export const config = {
  allowedBankTypes: {
    DEFAULT: [],
    // https://github.paypal.com/Checkout/xo-wallet-components/blob/master/src/add-card/creditcard-input/directive.js#L290
    MX: [
      'BANAMEX',
      'BANCOAZTECA',
      'BBVA',
      'BANORTE',
      'HSBC',
      'INBURSA',
      'SANTANDER',
    ],
  },

  // Used to populate the footer links
  // Put links in order that they should appear on page
  footerLinks: {
    DEFAULT: ['legalhub', 'privacy'],
    APAC: ['legalhub', 'userAgreement', 'privacy'], // eslint-disable-line sort-keys
    AT: ['imprint', 'legalhub', 'privacy'],
    AU: ['legalhub', 'privacy'],
    BE: ['legalhub', 'privacy'],
    C2: ['legalhub', 'privacy'],
    CH: ['imprint', 'legalhub', 'privacy'],
    DE: ['imprint', 'legalhub', 'privacy', 'serviceDescription'],
    DK: ['userAgreement', 'privacy'],
    EMEA: ['legalhub', 'userAgreement', 'privacy'],
    ES: ['legalhub', 'privacy'],
    HK: ['legalhub', 'privacy'],
    IT: ['legalhub', 'privacy'],
    LATAM: ['help', 'legalhub', 'privacy'],
    NL: ['legalhub', 'privacy'],
    NO: ['userAgreement', 'privacy'],
    PL: ['userAgreement', 'privacy'],
    RU: ['legalhub', 'privacy'],
    SE: ['userAgreement', 'privacy'],
    SG: ['legalhub', 'privacy'],
    TR: ['userAgreement', 'privacy'],
    US: ['policies', 'legalhub', 'privacy'],
  },

  /** Used to determine which are the Affected fields
   * by the select all functionality */
  selectAllSignupFields: {
    DEFAULT: [MARKETING_OPT_IN, SIGNUP_AGREE_TO_TERMS],
    KR: [
      MARKETING_OPT_IN,
      SIGNUP_AGREE_TO_TERMS,
      SIGNUP_AGREE_TO_PRIVACY_STATEMENTS,
      UNIQUE_INFORMATION_PROCESSING,
      THIRD_PARTY_DATA_CONSENT,
    ],
  },

  isInstallmentsEligible: {
    BR: true,
    MX: true,
  },

  /**
   * Used to determine which KYC (Know Your Customer) fields we need
   * to render for a particular country.
   *
   * TEMPORARY - Going to move this to a service that we can query
   */
  kycFields: {
    DEFAULT: KYC_DOB_NATIONALITY,
    AD: KYC_DOB_NATIONALITY_ID, // eslint-disable-line sort-keys
    AE: KYC_DOB_NATIONALITY_ID,
    AR: KYC_DOB_NATIONALITY_ID,
    AU: ['DateOfBirth'],
    BH: KYC_DOB_NATIONALITY_ID,
    BM: KYC_DOB_NATIONALITY_ID,
    BR: ['DateOfBirth', 'IdentityDocumentType', 'IdentityDocumentNumber'],
    BS: KYC_DOB_NATIONALITY_ID,
    BW: KYC_DOB_NATIONALITY_ID,
    C2: ['DateOfBirth', 'IdentityDocumentType', 'IdentityDocumentNumber'],
    CA: ['DateOfBirth', 'Occupation'],
    CH: ['DateOfBirth', 'IdentityDocumentType', 'IdentityDocumentNumber'],
    CL: KYC_DOB_NATIONALITY_ID,
    CO: KYC_DOB_NATIONALITY_ID,
    CR: KYC_DOB_NATIONALITY_ID,
    DO: KYC_DOB_NATIONALITY_ID,
    EC: KYC_DOB_NATIONALITY_ID,
    FO: KYC_DOB_NATIONALITY_ID,
    GE: KYC_DOB_NATIONALITY_ID,
    GL: KYC_DOB_NATIONALITY_ID,
    GT: KYC_DOB_NATIONALITY_ID,
    HK: [
      'DateOfBirth',
      'Gender',
      'PlaceOfBirth',
      'Nationality',
      'IdentityDocumentType',
      'IdentityDocumentNumber',
    ],
    HN: KYC_DOB_NATIONALITY_ID,
    HR: KYC_DOB_NATIONALITY_ID,
    ID: KYC_DOB_NATIONALITY_ID,
    IL: ['DateOfBirth', 'IdentityDocumentType', 'IdentityDocumentNumber'],
    IN: ['Nationality'],
    IS: KYC_DOB_NATIONALITY_ID,
    JP: ['Nationality', 'DateOfBirth'],
    JM: KYC_DOB_NATIONALITY_ID,
    JO: KYC_DOB_NATIONALITY_ID,
    KE: KYC_DOB_NATIONALITY_ID,
    KR: KYC_DOB_NATIONALITY_ID,
    KW: KYC_DOB_NATIONALITY_ID,
    KY: KYC_DOB_NATIONALITY_ID,
    KZ: KYC_DOB_NATIONALITY_ID,
    LS: KYC_DOB_NATIONALITY_ID,
    MA: KYC_DOB_NATIONALITY_ID,
    MC: KYC_DOB_NATIONALITY_ID,
    MD: KYC_DOB_NATIONALITY_ID,
    MU: KYC_DOB_NATIONALITY_ID,
    MX: ['DateOfBirth'],
    MY: KYC_DOB_NATIONALITY_ID,
    MZ: KYC_DOB_NATIONALITY_ID,
    NI: KYC_DOB_NATIONALITY_ID,
    NZ: KYC_DOB_NATIONALITY_ID,
    OM: KYC_DOB_NATIONALITY_ID,
    PA: KYC_DOB_NATIONALITY_ID,
    PE: KYC_DOB_NATIONALITY_ID,
    PH: KYC_DOB_NATIONALITY_ID,
    QA: KYC_DOB_NATIONALITY_ID,
    RS: KYC_DOB_NATIONALITY_ID,
    RU: [
      'CountryOfResidence',
      'IdentityDocumentType',
      'IdentityDocumentNumber',
      'DateOfBirth',
      'SecondaryIdentityDocumentType',
      'SecondaryIdentityDocumentNumber',
    ],
    SA: KYC_DOB_NATIONALITY_ID,
    SG: KYC_DOB_NATIONALITY_ID,
    SN: KYC_DOB_NATIONALITY_ID,
    SV: KYC_DOB_NATIONALITY_ID,
    TH: [
      'DateOfBirth',
      'Nationality',
      'IdentityDocumentType',
      'IdentityDocumentNumber',
    ],
    TW: KYC_DOB_NATIONALITY_ID,
    US: [],
    UY: KYC_DOB_NATIONALITY_ID,
    VE: KYC_DOB_NATIONALITY_ID,
    VN: KYC_DOB_NATIONALITY_ID,
    ZA: KYC_DOB_NATIONALITY_ID,
  },

  kycUsesNationalityOnChange: {
    DEFAULT: false,
    TH: true,
  },

  kycIdTypes: {
    DEFAULT: ['NATIONAL_ID', 'PASSPORT_NUMBER', 'DRIVERS_LICENSE'],
    BR: ['CPF'], // eslint-disable-line sort-keys
    HK: ['NATIONAL_ID', 'PASSPORT_NUMBER', 'TEMPORARY_NATIONAL_ID'],
    KR: ['PASSPORT_NUMBER', 'DRIVERS_LICENSE'],
    RU: ['PASSPORT_NUMBER'],
    TH: (nationality: string): string[] => {
      switch (nationality) {
        case 'TH':
          return ['NATIONAL_ID'];
        default:
          return ['PASSPORT_NUMBER'];
      }
    },
  },
  secondaryKycIdTypes: {
    DEFAULT: [],
    RU: ['TAX_IDENTIFICATION_NUMBER', 'PENSION_FUND_ID'],
  },

  kycIdentityDocumentNumberLabelKey: {
    DEFAULT: 'fieldLabels.identityDocumentNumber',
    TH: (nationality: string): string =>
      nationality === 'TH'
        ? 'fieldValues.NATIONAL_ID'
        : 'fieldValues.PASSPORT_NUMBER',
  },
};

export type ConfigType = typeof config;
export type ConfigKey = keyof ConfigType;
